import { AboutSecDetails } from "../config/dataConfig";
import { Link } from "react-scroll";

const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 text-center mb-5 mb-lg-0 wow fadeInUp">
            <img
              className="img-fluid shadow-md rounded d-inline-block"
              src="images/2.png"
              title="I'm Mekonnen Oda"
              alt=""
            />
          </div>
          <div
            className="col-lg-7 text-center text-lg-start ps-lg-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <h2 className="fw-600 mb-4">
              {AboutSecDetails.information.title1}
            </h2>
            <h3 className="text-6 mb-4">
              Hello!
              <span className="text-primary fw-600">
                {" "}
                I'm {AboutSecDetails.information.name}.
              </span>
            </h3>
            <p>{AboutSecDetails.information.desc1}</p>
            <p>{AboutSecDetails.information.desc2}</p>
            <div className="brands-grid separator-border my-sm-4">
              <div className="row">
                {AboutSecDetails.skills.map((skill, index) => (
                  <div
                    className="col-4 col-md-3 col-lg-2 py-3 d-flex justify-content-center align-items-center"
                    key={index}
                  >
                    <span
                      className="skill-icon-wrapper"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        background: "#f5f6fa",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                        transition: "box-shadow 0.2s",
                        fontSize: 32,
                      }}
                    >
                      <i
                        className={skill.icon + " text-primary"}
                        style={{ fontSize: 32 }}
                      ></i>
                    </span>
                  </div>
                ))}
              </div>
            </div>
            {/* <a
              className="btn btn-secondary rounded-pill mt-3"
              data-bs-toggle="modal"
              data-bs-target="#about-us-details"
              href="#about-us-details"
            >
              About more
            </a> */}
            <Link
              to="portfolio"
              spy={true}
              smooth={true}
              duration={600}
              className="btn btn-secondary rounded-pill mt-3 me-3"
              style={{ cursor: "pointer" }}
            >
              Go to Projects
            </Link>
            <Link
              to="contact"
              spy={true}
              smooth={true}
              duration={600}
              className="btn btn-secondary rounded-pill mt-3"
              style={{ cursor: "pointer" }}
            >
              Contact Me
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
